var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 52.5 52.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.82 26.53c0 .42-.16.84-.48 1.16L19.84 50.2c-.64.64-1.69.64-2.33 0l-7.14-7.14c-.32-.31-.5-.75-.48-1.19.01-.45.2-.87.52-1.18l15.18-14.17L10.41 12.37c-.33-.31-.52-.73-.52-1.18 0-.5.16-.88.48-1.19l7.14-7.14c.64-.64 1.69-.64 2.33 0l22.5 22.5c.32.32.48.74.48 1.17z",
    fill: "#ea9301"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPoint);
export default __webpack_public_path__ + "static/media/bullet_point.6afeeb183f5c3593810cedd2d815e17b.svg";
export { ForwardRef as ReactComponent };